"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StatusColors = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n  display: inherit;\n  width: 100%;\n  height: auto;\n  padding: 13px 4px 12px 4px;\n  justify-content: center;\n  flex-basis: 90%;\n  text-decoration: none;\n"], ["\n  display: inherit;\n  width: 100%;\n  height: auto;\n  padding: 13px 4px 12px 4px;\n  justify-content: center;\n  flex-basis: 90%;\n  text-decoration: none;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: inherit;\n  text-align: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  width: 97.5%;\n  white-space: pre-wrap;\n"], ["\n  display: inherit;\n  text-align: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  width: 97.5%;\n  white-space: pre-wrap;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: 0.1px;\n"], ["\n  font-family: ", ";\n  color: ", ";\n  font-size: 12px;\n  line-height: 1.25;\n  letter-spacing: 0.1px;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  @media (max-width: 768px) {\n    font-size: 14px;\n    font-weight: ", ";\n  }\n  @media (min-width: 768px) {\n    font-size: 18px;\n    font-weight:", ";\n  }\n  line-height: 1.25;\n  letter-spacing: 0.1px;\n  text-decoration: underline;\n  cursor: pointer;\n  :hover {\n    color: white;\n    opacity: 0.9;\n  }\n  :focus {\n    outline: 3px solid #FFF;\n    background-color: #0042CB;\n    color: #FFF;\n    box-shadow: inset 0 0 20px 0 rgba(0, 0, 0, 0.3);\n  }\n"], ["\n  font-family: ", ";\n  color: ", ";\n  @media (max-width: 768px) {\n    font-size: 14px;\n    font-weight: ", ";\n  }\n  @media (min-width: 768px) {\n    font-size: 18px;\n    font-weight:", ";\n  }\n  line-height: 1.25;\n  letter-spacing: 0.1px;\n  text-decoration: underline;\n  cursor: pointer;\n  :hover {\n    color: white;\n    opacity: 0.9;\n  }\n  :focus {\n    outline: 3px solid #FFF;\n    background-color: #0042CB;\n    color: #FFF;\n    box-shadow: inset 0 0 20px 0 rgba(0, 0, 0, 0.3);\n  }\n"]),
    _templateObject5 = _taggedTemplateLiteral(["  \n  width: 100%;\n  @media (max-width: 768px) {\n    width: 90%;\n  }\n  z-index: 98;\n  opacity: 0.9;\n"], ["  \n  width: 100%;\n  @media (max-width: 768px) {\n    width: 90%;\n  }\n  z-index: 98;\n  opacity: 0.9;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  transform: ", ";\n  transition: transform 0.3s ease;\n  ", ";\n  background-color: #196cff;\n  :hover {\n    background-color: #033db6;\n    transition: 0.3s ease;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  transform: ", ";\n  transition: transform 0.3s ease;\n  ", ";\n  background-color: #196cff;\n  :hover {\n    background-color: #033db6;\n    transition: 0.3s ease;\n  }\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

var _buoyCloseIcon = require("buoy-close-icon");

var _buoyCloseIcon2 = _interopRequireDefault(_buoyCloseIcon);

var _dist = require("react-intl/dist");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StatusColors = exports.StatusColors = {
  INFO: _buoyTheme.colors.primary,
  ERROR: _buoyTheme.colors.landingRedLight
};

var Message = _styledComponents2.default.div.withConfig({
  displayName: "src__Message",
  componentId: "sc-1wxdyer-0"
})(_templateObject);

var MessageWrapper = _styledComponents2.default.div.withConfig({
  displayName: "src__MessageWrapper",
  componentId: "sc-1wxdyer-1"
})(_templateObject2);

var MessageText = _styledComponents2.default.span.withConfig({
  displayName: "src__MessageText",
  componentId: "sc-1wxdyer-2"
})(_templateObject3, _buoyTheme.fontFamily, _buoyTheme.colors.neutralLightest);
var MessageLink = _styledComponents2.default.a.withConfig({
  displayName: "src__MessageLink",
  componentId: "sc-1wxdyer-3"
})(_templateObject4, _buoyTheme.fontFamily, _buoyTheme.colors.white, _buoyTheme.fontWeight.medium, _buoyTheme.fontWeight.light);

var Alert = _styledComponents2.default.div.withConfig({
  displayName: "src__Alert",
  componentId: "sc-1wxdyer-4"
})(_templateObject5);

var AlertWrapper = _styledComponents2.default.div.withConfig({
  displayName: "src__AlertWrapper",
  componentId: "sc-1wxdyer-5"
})(_templateObject6, function (props) {
  return props.visible ? "translateY(0)" : "translateY(-250%)";
}, function (props) {
  return props.topBanner ? "top: 0" : "top: 1px";
});

var AlertMessage = function AlertMessage(props) {
  var message = props.message,
      status = props.status;

  return _react2.default.createElement(
    Message,
    null,
    _react2.default.createElement(
      MessageWrapper,
      null,
      message && message.text.map(function (msg) {
        return _react2.default.createElement(
          MessageText,
          { status: status },
          msg
        );
      })
    )
  );
};

var AlertBanner = function (_React$Component) {
  _inherits(AlertBanner, _React$Component);

  function AlertBanner(props) {
    _classCallCheck(this, AlertBanner);

    var _this = _possibleConstructorReturn(this, (AlertBanner.__proto__ || Object.getPrototypeOf(AlertBanner)).call(this, props));

    _this.handleResize = function () {
      if (_this.alertRef && _this.alertRef.current && _this.alertRef.current.clientHeight !== _this.state.height) _this.setState({ height: _this.alertRef.current.clientHeight });
    };

    _this.dismiss = function () {
      _this.setState({ visible: false, aboveNav: false }, function () {
        setTimeout(function () {
          _this.props.onDismiss();
        }, 500);
      });
    };

    _this.getMessage = function (variant) {
      // Default message if no variant given
      var message = {
        type: "default",
        text: ["This is an alert banner with placeholder text."]
      };
      return message;
    };

    _this.state = { visible: false, aboveNav: true, height: 0 };
    _this.alertRef = _react2.default.createRef();
    return _this;
  }

  _createClass(AlertBanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Do this to show initial transition in
      this.setState({ visible: true, height: this.alertRef.current.clientHeight });
      window.addEventListener("resize", this.handleResize);
    }
    // detect alert height change if user resizes browser

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          variant = _props.variant,
          status = _props.status,
          topBanner = _props.topBanner;
      var _state = this.state,
          visible = _state.visible,
          height = _state.height;


      return _react2.default.createElement(
        AlertWrapper,
        {
          visible: visible,
          variant: variant,
          topBanner: topBanner,
          innerRef: this.alertRef
        },
        _react2.default.createElement(
          Alert,
          null,
          _react2.default.createElement(AlertMessage, {
            message: this.getMessage(variant),
            status: status,
            onDismiss: this.dismiss,
            variant: variant
          })
        ),
        _react2.default.createElement(_buoyCloseIcon2.default, {
          size: "36px",
          iconSize: "16px",
          color: _buoyTheme.colors.neutralLightest,
          onClick: function onClick() {
            _this2.dismiss();
          },
          topBanner: topBanner,
          padding: "10px",
          top: "6px",
          right: "12px",
          alertHeight: height
        })
      );
    }
  }]);

  return AlertBanner;
}(_react2.default.Component);

AlertBanner.defaultProps = {
  onDismiss: function onDismiss() {},
  variant: ""
};

exports.default = AlertBanner;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-alert/dist/index.js
// module id = 387
// module chunks = 168707334958949